import type { LoadableOptions } from 'ui-component/Loadable';
import TabPanelSkeleton from 'ui-component/tabs/TabPanelSkeleton';

/** אופציה ל־Loadable — Skeleton בשטח התוכן (זהה כעת לברירת המחדל של Loadable) */
export const tabPanelLoadableOptions: LoadableOptions = {
  suspenseFallback: <TabPanelSkeleton />,
};
